import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  TaggedGroup,
  TaggingResolutionChoice,
  TaggingValidation,
  TaggingValidationType,
  Vendor as TagVendor,
} from '../tag-item-vendor.service';
import {
  ExtendedKeycloakUser,
  StoreDropdowns,
} from 'src/app/shared/models/app-models';
import { Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';

export interface TaggingValidationDialogData extends TaggingValidation {}

export interface TaggingValidationDialogFormData {
  choice: TaggingResolutionChoice | null;
}

export interface TaggingValidationDialogActionResult {
  data: TaggingValidationDialogData;
  form: TaggingValidationDialogFormData;
}

export type TaggingValidationDialogResult =
  | undefined
  | TaggingValidationDialogActionResult;

@Component({
  selector: 'app-tagging-validation-dialog',
  templateUrl: './tagging-validation-dialog.component.html',
  styleUrls: ['./tagging-validation-dialog.component.scss'],
})
export class TaggingValidationDialogComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  dpOptions!: StoreDropdowns;
  public formData: TaggingValidationDialogFormData = {
    choice: null,
  };

  constructor(
    private store: Store<{
      dp: StoreDropdowns;
    }>,
    public dialogRef: MatDialogRef<TaggingValidationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TaggingValidationDialogData
  ) {
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.dpOptions = dp;
      });
  }

  ngOnInit() {
    const { type } = this.data;

    // Set initial data
    switch (type) {
      case TaggingValidationType.DUPLICATED_VENDOR_SET:
        this.formData.choice = TaggingResolutionChoice.MERGE;
        break;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  onDialogAction() {
    const result: TaggingValidationDialogActionResult = {
      data: this.data,
      form: this.formData,
    };

    this.dialogRef.close(result);
  }

  public concatVendorElement(
    element: keyof TagVendor,
    vendors?: TaggedGroup['vendors']
  ) {
    if (!vendors) {
      return 'Not selected';
    }
    return vendors.map((vendor) => vendor[element]).join(', ');
  }

  public get TaggingValidationType(): typeof TaggingValidationType {
    return TaggingValidationType;
  }
  public get TaggingResolutionChoice(): typeof TaggingResolutionChoice {
    return TaggingResolutionChoice;
  }

  public getUserDisplayName(username?: string) {
    if (!this.dpOptions || !this.dpOptions.UserList || !username) {
      return '-';
    }

    return (
      (this.dpOptions.UserList as ExtendedKeycloakUser[]).find((user) => {
        return user.id === username;
      })?.last_name ?? '-'
    );
  }
}
